import React from "react";
import FooterOne from "../Footer/FooterOne";
import Header from "../Header/HeaderTwo";
import { pageTitle } from "../PageTitle";

const ServicesDetails = () => {
  pageTitle("Services Details");
  return (
    <>
      <Header></Header>
      <div className="services__details section-padding">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-8">
              <div className="services__details-left">
                <div
                  className="services__details-left-content mb-40"
                  style={{ paddingTop: "13%" }}
                >
                  {/* <h2 className="mb-30">Terms & Conditions</h2> */}
                  <div className="contact__area-title">
                    <span className="subtitle">Terms & Conditions</span>
                  </div>
                  <p style={{ marginBottom: "1.5rem" }}>
                    Welcome to the Euphoria Group app! These terms and
                    conditions outline the rules and regulations governing your
                    use of the app. By using the app, you agree to comply with
                    these terms. If you do not agree, please do not use the app.
                  </p>
                  <h4>Services Provided :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    The Euphoria Group app allows users to:
                    <ul>
                      <li className="mt-2">
                        View purchased residential/real estate units.
                      </li>
                      <li className="mt-2">
                        Access prices, outstanding amounts, and payment due
                        dates.
                      </li>
                      <li className="mt-2">
                        Communicate with the support team via chat.
                      </li>
                      <li className="mt-2">
                        View marketing offers and other services.
                      </li>
                    </ul>
                  </p>
                  <h4>Account Registration :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        Users cannot create their own accounts; the company is
                        responsible for creating and providing accounts to
                        users.
                      </li>
                      <li className="mt-2">
                        Users are responsible for all activities conducted under
                        their accounts.
                      </li>
                    </ul>
                  </p>

                  <h4>User Data & Privacy :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        The app may collect personal information such as names
                        and contact details to provide services.
                      </li>
                      <li className="mt-2">
                        All data collection and usage comply with applicable
                        data protection regulations, including GDPR and CCPA
                        where applicable.
                      </li>
                      <li className="mt-2">
                        Users can request access to their data or its deletion
                        by contacting the company through the official
                        communication channels.
                      </li>
                      <li className="mt-2">
                        The app does not share personal user data with third
                        parties except as required for operational or legal
                        purposes.
                      </li>
                    </ul>
                  </p>

                  <h4>Prices and Payments :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        All prices listed in the app reflect the prices of
                        purchased units and are not available for sale.
                      </li>
                      <li className="mt-2">
                        Users are required to pay outstanding amounts according
                        to the payment schedules provided in the app.
                      </li>
                      <li className="mt-2">
                        Euphoria Group reserves the right to cancel or modify
                        any order based on operational circumstances.
                      </li>
                      <li className="mt-2">
                        Payment information is securely processed, and users are
                        responsible for ensuring timely payments.
                      </li>
                    </ul>
                  </p>

                  <h4>Communication with Support :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        Users can contact the support team through the chat
                        feature available in the app.
                      </li>
                      <li className="mt-2">
                        Users must not misuse the chat feature, send
                        inappropriate messages, or engage in harassment.
                      </li>
                    </ul>
                  </p>

                  <h4>Content and Advertisements :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        The app may contain advertisements and promotional
                        offers related to Euphoria Group’s services.
                      </li>
                      <li className="mt-2">
                        The company reserves the right to send marketing
                        notifications to users.
                      </li>
                      <li className="mt-2">
                        Users may opt out of receiving marketing communications
                        via the app settings or by contacting support.
                      </li>
                    </ul>
                  </p>

                  <h4>Intellectual Property Rights :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        All content, designs, and trademarks in the app are the
                        exclusive property of Euphoria Group.
                      </li>
                      <li className="mt-2">
                        Copying or republishing any part of the app without
                        prior written permission is prohibited.
                      </li>
                    </ul>
                  </p>

                  <h4>Disclaimer :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        Euphoria Group is not responsible for any errors or
                        delays in updating prices or other information.
                      </li>
                      <li className="mt-2">
                        The app provides informational guidance, and any
                        financial or purchasing decisions are the user’s
                        responsibility.
                      </li>
                      <li className="mt-2">
                        The company does not guarantee uninterrupted service and
                        is not liable for any technical issues beyond its
                        control.
                      </li>
                    </ul>
                  </p>

                  <h4>Changes to Terms :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        Euphoria Group reserves the right to modify these terms
                        and conditions at any time.
                      </li>
                      <li className="mt-2">
                        Users will be notified of any significant updates
                        through the app or via email.
                      </li>
                    </ul>
                  </p>

                  <h4>Data Deletion Policy :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        Users can request deletion of their account and
                        associated data by contacting support through the app or
                        via email.
                      </li>
                      <li className="mt-2">
                        Upon request, Euphoria Group will process data deletion
                        in compliance with applicable laws and regulations.
                      </li>
                    </ul>
                  </p>

                  <h4>Governing Law :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    <ul>
                      <li className="mt-2">
                        These terms and conditions are governed by the laws of
                        the country in which Euphoria Group operates.
                      </li>
                      <li className="mt-2">
                        Any disputes arising shall be resolved through the
                        appropriate judicial authorities.
                      </li>
                    </ul>
                  </p>

                  <h4>Contact Us :</h4>
                  <p style={{ marginBottom: "1.5rem" }}>
                    If you have any inquiries about these terms, you can contact
                    us via:
                    <ul>
                      <li className="mt-2">The chat feature within the app.</li>
                      <li className="mt-2">
                        The company’s official email at:
                        <a href="mailto:Support@euphoriagroup.com.eg">
                          {" "}
                          Support@euphoriagroup.com.eg
                        </a>
                      </li>
                      <li className="mt-2">
                        Our official website:
                        <a
                          href="https://euphoriagroup.com.eg"
                          target="_blank"
                          className="text-lowercase"
                        >
                          {""} www.euphoriagroup.com.eg
                        </a>
                      </li>
                    </ul>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterOne></FooterOne>
    </>
  );
};

export default ServicesDetails;
